import clsx from 'clsx';
import React from 'react';
import { Container } from 'react-bootstrap';

import handShakeIcon from 'images/partners/hand-shake.svg';

import usePartners from '../../hooks/usePartners';
import { Spinner } from '../BaseUI';
import MetaTags from '../shared/MetaTags';
import PartnerCard from './PartnerCard';
import PartnershipOpportunitiesSection from './PartnershipOpportunitiesSection';
import styles from './styles.module.css';

const Partners = () => {
  const { partners, isLoadingPartners } = usePartners();
  const description =
    'Our readers are an elite audience of Founders, ' +
    'Partners, CEOs and senior executives who are highly engaged with our content. ' +
    'They come to The Information for their news and to stay ahead. ' +
    'They look to our brand partners to build relationships. ' +
    'The Information offers reach to tech leaders and financial power brokers. ' +
    'These are the people looking to innovative new partners and who can write the checks.';

  return (
    <>
      <MetaTags
        title="The Information Partners"
        description={description}
        ogSiteName="The Information"
      />
      {isLoadingPartners ? (
        <Spinner />
      ) : (
        <>
          <Container>
            <img src={handShakeIcon} className={styles.handShakeIcon} />
            <div className={styles.partnersTitle}>
              <div className={clsx(styles.titleDesign, styles.leftSide)}></div>
              <h1 className={styles.title}>Partners</h1>
              <div className={clsx(styles.titleDesign, styles.rightSide)}></div>
            </div>
            {partners.length > 0 && (
              <div className={styles.partnersContainer}>
                {partners.map((partner, i) => (
                  <PartnerCard key={i} partner={partner} />
                ))}
              </div>
            )}
          </Container>
          <PartnershipOpportunitiesSection />
        </>
      )}
    </>
  );
};

export default Partners;
